import { render, staticRenderFns } from "./SlotsList.vue?vue&type=template&id=06d90f9e&scoped=true"
import script from "./SlotsList.vue?vue&type=script&lang=js"
export * from "./SlotsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d90f9e",
  null
  
)

export default component.exports